import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { v4 as uuidv4 } from "uuid";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { FormattedMessagingTemplate, MessagingTemplate } from "@idw-types/data/messaging-template";
import { TemplateAvailabilityLevelTypes } from "@enums/template-availability-level-types";
import { getUnformattedLanguageFiles } from "@utils/messaging-template/messaging-template-util";

export const formatMessagingTemplates = (
    messagingTemplates: Array<MessagingTemplate>,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>
): Array<FormattedMessagingTemplate> => {
    return messagingTemplates.map(rp => formatMessagingTemplate(rp, companies, relyingParties));
};
const getTemplateAvailabilityLevel = (companyId: string, relyingPartyId: string): TemplateAvailabilityLevelTypes => {
    if (!companyId && !relyingPartyId) {
        return TemplateAvailabilityLevelTypes.GLOBAL;
    } else if (companyId && !relyingPartyId) {
        return TemplateAvailabilityLevelTypes.ORGANIZATION;
    } else {
        return TemplateAvailabilityLevelTypes.RELYING_PARTY;
    }
}

export const formatMessagingTemplate = (
    messagingTemplate: MessagingTemplate,
    companies: Array<AxnCompany>,
    relyingParties: Array<AxnRelyingParty>
): FormattedMessagingTemplate => {
    const company = companies.find(c => c.id === messagingTemplate.companyID) || null;
    const relyingParty = relyingParties.find(rp => rp.id === messagingTemplate.relyingPartyID) || null;

    const languageFiles: Partial<MultiLanguageWrapper<any>> = {};
    try {
        if (messagingTemplate.languageFiles && Object.keys(messagingTemplate.languageFiles).length > 0) {
            (Object.keys(messagingTemplate.languageFiles) as Array<LocaleTypes>).forEach(locale => {
                const localeJSON = JSON.parse(messagingTemplate.languageFiles[locale]) || {};
                languageFiles[locale] = localeJSON;
            });
        }
    } catch (error) {
        console.error(`error parsing language file string:`, error);
    }

    return {
        id: messagingTemplate.id,
        uuid: messagingTemplate.uuid,
        template: messagingTemplate.template,
        name: messagingTemplate.name,
        status: messagingTemplate.status,
        type: messagingTemplate.type,
        temporaryUUID: messagingTemplate.uuid || uuidv4(),
        company,
        relyingParty,
        languageFiles,
        permissions: messagingTemplate.permissions,
        templateAvailabilityLevel: getTemplateAvailabilityLevel(messagingTemplate.companyID, messagingTemplate.relyingPartyID)
    };
};

export const unformatMessagingTemplate = (
    messagingTemplate: FormattedMessagingTemplate
): MessagingTemplate => {
    const { id, uuid, template, name, type, status, company, relyingParty, languageFiles } = messagingTemplate;

    return {
        id,
        uuid,
        template,
        name: name,
        status,
        type,
        companyID: company.id,
        relyingPartyID: relyingParty?.id,
        languageFiles: getUnformattedLanguageFiles(languageFiles),
        permissions: messagingTemplate?.permissions
    };
};